export default __webpack_public_path__ + "static/media/email.79a49549.svg";